import { api } from "@/api/axios.ts";
import { ApiCurrency } from "@/types/currency.types.ts";

export const apiCurrencies = {
  getAll: () => {
    return api.get<ApiCurrency[]>("/api/v1/currencies");
  },
};
